const pagesRoutes = {
  pages: 'pages',
  containers: {
    termsOfService: 'terms-of-service',
    privacyPolicy: 'privacy-policy',
  },
};

export default pagesRoutes;
